import { Grid } from '@mui/material';
import React from 'react';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import ControlledInputPassword from 'components/common/forms/controlled_input_password';
import ControlledInputSelect from 'components/common/forms/controlled_input_select';
import ControlledCheckbox from 'components/common/forms/controlled_checkbox';
import { useTranslation } from 'react-i18next';
import { buildLegalLink } from 'utilities/links';
import { useFormContext } from 'react-hook-form';
import {
  BIRTHDATE_REGEX,
  SIN_REGEX,
  EXPERIAN_PATTERNS,
  POSTAL_CODE_REGEX_BY_COUNTRY,
} from 'constants/patterns';
import { CA_PROVINCE_MAPPINGS } from 'constants/mappings';
import { DATADOG_PRIVACY_LEVELS } from 'constants/enums';

const Fields = (props) => {
  const { applicationData, disabled } = props;
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.firstName')}
          name="personal_first_name"
          control={control}
          rules={{
            required: true,
          }}
          disabled
          defaultValue={applicationData.personal_first_name || ''}
          autocomplete="given-name"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.lastName')}
          name="personal_last_name"
          control={control}
          rules={{
            required: true,
          }}
          disabled
          defaultValue={applicationData.personal_last_name || ''}
          autocomplete="family-name"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.dateOfBirth')}
          name="personal_birthdate"
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: BIRTHDATE_REGEX,
          }}
          defaultValue={applicationData.personal_birthdate || ''}
          placeholder="YYYY-MM-DD"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputPassword
          label={t('checkout.label.sin')}
          name="personal_sin"
          control={control}
          disabled={disabled}
          rules={{
            pattern: SIN_REGEX,
          }}
          placeholder="000 000 000"
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ControlledInputText
          label={t('checkout.label.addressLine1')}
          name="personal_street_1"
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: EXPERIAN_PATTERNS.street,
          }}
          defaultValue={applicationData.personal_street_1 || ''}
          autocomplete="address-line1"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.addressLine2')}
          name="personal_street_2"
          defaultValue={applicationData.personal_street_2 || ''}
          control={control}
          rules={{
            pattern: EXPERIAN_PATTERNS.street,
          }}
          disabled={disabled}
          autocomplete="address-line2"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.city')}
          name="personal_city"
          defaultValue={applicationData.personal_city || ''}
          control={control}
          disabled={disabled}
          rules={{
            pattern: EXPERIAN_PATTERNS.city,
            required: true,
          }}
          autocomplete="address-level2"
        />
      </Grid>
      <Grid item xs={12} md={4} data-dd-privacy={DATADOG_PRIVACY_LEVELS.HIDDEN}>
        <ControlledInputSelect
          name="personal_state_province"
          control={control}
          disabled={disabled}
          defaultValue={applicationData.personal_state_province || ''}
          rules={{ required: true }}
          options={Object.entries(CA_PROVINCE_MAPPINGS).map(([a, b]) => {
            return { value: a, displayValue: t(b) };
          })}
          label={t('checkout.label.state')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.postalCode')}
          name="personal_postal_code"
          disabled={disabled}
          defaultValue={applicationData.personal_postal_code || ''}
          control={control}
          rules={{
            required: true,
            pattern: POSTAL_CODE_REGEX_BY_COUNTRY.CA,
          }}
        />
      </Grid>
      <Grid item xs={12} md={12} mb={2}>
        <ControlledCheckbox
          name="accepted_legal_agreements"
          control={control}
          disabled={disabled}
          label={
            <div
              dangerouslySetInnerHTML={{
                __html: t('checkout.financeApp.legal_agreement_html', {
                  privacyLink: buildLegalLink('/privacy'),
                  esignLink: buildLegalLink('/sign'),
                  creditLink: buildLegalLink('/shop-credit-authorization'),
                }),
              }}
            />
          }
          defaultValue={applicationData.accepted_legal_agreements || false}
          rules={{ required: true }}
        />
      </Grid>
    </>
  );
};

export default Fields;
